export default __webpack_public_path__ + "static/media/pegaCenter.0e1310ea.png";